import Reveal from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" id="contact" className="py-24 md:py-32 bg-[#121316]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <Reveal className="lg:col-span-5 text-white">
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-blue-300 font-mono">Book a demo</p>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-medium tracking-tight leading-tight">
              See WebADAC against your own ADAC file.
            </h2>
            <p className="mt-5 text-lg text-zinc-400 leading-relaxed">
              Tell us a little about your workflow. A specialist will walk you through validation,
              comparison, and profiling — and show how to cut resubmissions for good.
            </p>
            <ul className="mt-8 space-y-3 text-sm text-zinc-300">
              <li className="font-mono">→ 30-minute focused walkthrough</li>
              <li className="font-mono">→ Tailored to Councils or Consultants</li>
              <li className="font-mono">→ No obligation, no setup required</li>
            </ul>
            <a
              href="/#pricing"
              data-testid="final-cta-pricing-link"
              className="mt-8 inline-flex items-center gap-2 text-sm font-medium text-white border border-zinc-700 hover:border-zinc-500 hover:bg-white/5 transition-colors px-5 py-2.5 rounded-sm"
            >
              See plans & pricing →
            </a>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-7">
            <div className="rounded-2xl bg-zinc-900 border border-zinc-800 p-8 md:p-10">
              <LeadForm dark />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
